import React from 'react'
import { Link } from 'react-router-dom'

interface ICardLinkProps {
  to: string
  children: React.ReactNode
  newTab?: boolean
  className?: string
  style?: React.CSSProperties
}

// Ссылка на карточку продавца или покупателя. Стоит в строках, которые сами
// открываются по клику, поэтому клик по ссылке до строки не доходит
export const CardLink: React.FC<ICardLinkProps> = ({
  to,
  children,
  newTab,
  className,
  style
}) => (
  <Link
    to={to}
    className={className}
    style={style}
    onClick={(event) => event.stopPropagation()}
    {...(newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
  >
    {children}
  </Link>
)
